// @ts-nocheck
import { populate } from 'populate';
import type { Container, Graphics, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9df95aa8-173c-4fb3-991f-d0f30462edb3',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'f1f798b2-0e62-4986-b268-7b92a0f6cee0',
      type: 'Graphics',
      name: 'background',
      className: '',
      x: 0,
      y: 5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9df95aa8-173c-4fb3-991f-d0f30462edb3',
      commands: [
        {
          id: '48f92cde-e455-478d-838b-2aef6aca6cdf',
          type: 'beginFill',
          color: 14540253,
          alpha: 1
        },
        {
          id: 'cb9a6f1b-c21f-4fe5-b3c6-9b2c895e3f6c',
          type: 'drawRoundedRect',
          x: 0,
          y: 0,
          width: 160,
          height: 20,
          radius: 8
        },
        {
          id: 'de52f2a6-2fe6-4d92-ba8d-f4f3a21b7797',
          type: 'beginFill',
          color: 14540253,
          alpha: 1
        }
      ]
    },
    {
      id: 'bc0a2a21-0f9a-4a54-a877-53b48ebec332',
      type: 'Sprite',
      name: 'knob',
      className: '',
      x: 17,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'Rectangle',
        x: -40,
        y: -40,
        width: 80,
        height: 80
      },
      texture: 'UI_Toggle_Knob',
      parent: '9df95aa8-173c-4fb3-991f-d0f30462edb3'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'on',
    'off'
  ],
  handleResize: false
} as const;

export class SettingsSliderLayout {
  static raw = raw;
  root!: Container;
  background!: Graphics;
  knob!: Sprite;
  StateName!: 'on' | 'off';

  constructor() {
    populate(this, raw);
  }
}
